import {
    IShippingOauthLinkResponse,
    SHIPPING_CONNECTION_CODE
} from "../../../../../../models/IntegrationsTypes";
import { TYPE, rootContainer } from "../../../../../../services/container/root";
import OAuthHandler, {IEventMessage} from "../oauth-handler/outh-handler";
import ShippingIntegrationsService, {
    ICreateOauthLinkBody
} from "../../../../../../services/api/shipping-integrarions-service";

class ShippingOAuthHandler extends OAuthHandler<IShippingOauthLinkResponse> {
    private readonly _integrationCode: SHIPPING_CONNECTION_CODE;

    private get integrationsService(): ShippingIntegrationsService {
        return rootContainer.get<ShippingIntegrationsService>(TYPE.ShippingIntegrationsService);
    }

    constructor(integrationCode: SHIPPING_CONNECTION_CODE) {
        super();
        this._integrationCode = integrationCode;
    }

    protected async createLink(isSandbox: boolean, inputData?: Record<string, any>): Promise<IShippingOauthLinkResponse> {
        const body: ICreateOauthLinkBody = {
            credentials: inputData,
            is_sandbox: isSandbox
        };
        return this.integrationsService.createOauthLink(this._integrationCode, body);
    }

    protected async handleMessagePayload(event: IEventMessage, linkResponse: IShippingOauthLinkResponse, inputData?: Record<string, any>): Promise<unknown> {
        return {
            credentials: inputData,
            oauth_link_response: linkResponse,
            oauthPayload: event.data.payload,
        };
    }
}

export default ShippingOAuthHandler;
